export default __webpack_public_path__ + "static/media/AdBeasts_09.9c13f649.png";